import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: min(2.45vw, 35px) 0;
  align-items: center;
  background-color: #eaf4fb;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  .mobile-view-loading-page {
      display: none;
  }
  > div {
    flex: 1;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    padding: 8.47vw 0;
    .mobile-view-loading-page {
      display: block;
      width: 94.138vw;
  } 
  }
`;
const BlueArrowSection = styled.div`
  display: flex;
  align-items: center;
  .text-box {
    margin-left: min(6.86vw, 98px);
  }
  h2 {
    color: #fff;
    font-size: min(3.64vw, 52px);
    line-height: min(4.2vw, 60px);

    font-family: "robotoblack";
    position: relative;
    margin: 0;
    letter-spacing: -0.57px;
  }
  img {
    position: absolute;
    width: min(57.68vw, 824px);
    aspect-ratio: auto 824/414;
  }
  @media (max-width: 767px) {
    img {
      display: none;
    }
    .text-box {
        margin: 0 auto;
    }
    h2 {
        color: #095587;
        font-size: 8.7vw;
        line-height: 10.16vw;
        text-align: center;
    }
  }
`;

const TellMeMore = styled.div`
  max-width: clamp(336px,45.99vw, 657px);
  padding-bottom: min(1.68vw, 24px);
  h1 {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    font-family: "robotoregular";
    color: #095587;
    letter-spacing: -0.57px;
    margin: 0;
  }
  .truck-wrapper {
    padding-left: min(5.25vw, 75px);
    display: flex;
    button {
      width: min(11.13vw, 159px);
      height: min(2.73vw, 39px);
      font-size: min(1.19vw, 17px);
      border-radius: min(0.42vw, 6px);
      background-color: #095587;
      font-family: "robotoregular";
      color: #fff;
      border: none;
      margin-top: min(1.75vw, 25px);
    }
    .small-truck {
      width: min(15.12vw, 216px);
      aspect-ratio: auto 216/254;
    }
    .big-truck {
      width: min(20.65vw, 295px);
      aspect-ratio: auto 295/318;
    }
    > div {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      padding-left: 30px;
    }
  }
  @media (max-width: 767px) {
      margin: 0 auto;
      max-width: 81.31vw;
      padding: 0;
      h1 {
          font-size: 4.84vw;
          line-height: 6.292vw;
          max-width: 100%;
            text-align: center;
        margin: 3.63vw 0;
      }
    img {
      display: none;
    }
    .truck-wrapper {
        padding: 0;
    justify-content: center;
    button {
        width: 31.70vw;
    height: 7.74vw;
    font-size: 3.38vw;
    border-radius: 6px;
    margin-bottom: 8.47vw;
    }
    }
  }
`;

export { Container, Wrapper, BlueArrowSection, TellMeMore };
